import { NAV_LINKS, WHATSAPP_URL, EMAIL_URL } from "@/constants/links";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-ujn-accent/25 bg-ujn-deeper text-ujn-offwhite">
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-heading text-base font-bold tracking-[0.14em]">PT UTAMA JAYA NITYA</p>
          <p className="mt-2 font-mono text-[10px] tracking-[0.2em] text-ujn-subtle">
            BULK LIQUID STORAGE &amp; HANDLING PARTNER
          </p>
          <p className="mt-4 text-sm text-ujn-offwhite/60">Probolinggo, East Java, Indonesia</p>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.24em] text-ujn-subtle">NAVIGATION</p>
          <nav className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`footer-${link.testId}`}
                className="font-mono text-[11px] tracking-[0.16em] text-ujn-offwhite/65 transition-colors duration-200 hover:text-ujn-offwhite"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div>
          <p className="font-mono text-[10px] tracking-[0.24em] text-ujn-subtle">CONTACT</p>
          <div className="mt-4 space-y-2.5 text-sm text-ujn-offwhite/75">
            <p data-testid="footer-contact-person">Hostiadi — Administration</p>
            <p>
              WhatsApp —{" "}
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="transition-colors duration-200 hover:text-ujn-offwhite"
              >
                +62 822-2955-4434
              </a>
            </p>
            <p>
              Email —{" "}
              <a
                href={EMAIL_URL}
                data-testid="footer-email-link"
                className="transition-colors duration-200 hover:text-ujn-offwhite"
              >
                utamajaya.n@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="mt-12 border-t border-ujn-accent/20 pt-6">
        <p className="font-mono text-[10px] tracking-[0.18em] text-ujn-offwhite/45">
          © 2026 PT UTAMA JAYA NITYA. ALL RIGHTS RESERVED.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
